<template>
  <div class="c-select-account">
    <Row :gutter="18">
      <Spin size="large" fix v-if="loading" />
      <Col span="12">
        <group-box v-model="keyword" :data="data" :level="1" title="计划账号/计划主ID" class="c-account" @on-select="selectAll">
          <group-item :data="data" :checkedList="checkedList" :keyword="keyword" @on-select="selectAll" @on-check="checkItem" />
        </group-box>
      </Col>

      <Col span="3" offset="1" class-name="m-result">
        <div class="m-wrap m-box">
          <group-box :title="`已选 ${checkedList.length} 项`" result @on-clear="clearAll">
            <div v-for="item in checkedList" :key="item.id" class="c-pop-tip">
              <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}/{{ item.advertiserId }}</Tag>
            </div>
          </group-box>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, getKeyOfData } from '@/common/js/utils'
import GroupBox from './group-box'
import GroupItem from './group-item'
export default {
  name: 'selectAccount',
  components: { GroupBox, GroupItem },
  props: {
    value: {
      type: Array,
      required: true
    },
    data: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    checkedList: {
      default() {
        return []
      },
      type: Array
    }
  },
  methods: {
    selectAll({ check }) {
      this.$emit('select-all', check)
    },
    checkItem(item) {
      this.$emit('on-check', item)
    },
    handleClose(event, id) {
      const item = getKeyOfData(this.data, 'id', id)
      this.checkedList.forEach((ret, index) => {
        if (ret.id === id) this.checkedList.splice(index, 1)
      })
      if (isArray(item.children) && item.children.length) {
        this.$emit('on-select', { list: this.data, check: false, current: id })
      } else {
        this.$set(item, 'check', false)
      }
    },
    clearAll() {
      this.data.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      this.$emit('on-clear')
    }
  },
  data() {
    return {
      keyword: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-account {
  width: 100%;

  .c-account {
    width: 300px;
    border: 1px solid #e8eaec;
  }

  .m-result {
    min-width: 280px;
    margin-left: 20px;

    .m-wrap {
      border: 1px solid #e8eaec;
    }

    ::v-deep .c-content {
      height: 368px;
    }

    .c-pop-tip {
      width: 100%;
    }

    .c-tag-item {
      width: 90%;
      margin: 8px 8px 0;
      padding: 2px 6px;
      display: block;
      font-size: 14px;
      height: 28px;
      z-index: 2;

      ::v-deep .ivu-tag-text {
        display: inline-block;
        max-width: 195px;
        overflow: hidden;
        text-overflow: ellipse;
        white-space: nowrap;
      }

      ::v-deep .ivu-icon-ios-close {
        float: right;
        margin: 5px 0 0 0;
      }
    }
  }
}
</style>
